import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getParams, readQueryParameter } from './utils/pageInfo';
import { sendEvent } from './utils/dataGrinch';
import { getPageInfo } from './utils/pageInfo.js';
import { calculatePriceInfo } from './utils/products.js';
import { readCookie } from './components/common/Cookie';
import { checkFingerPrintDetails } from './utils/fingerPrint.js';
import { getLuxeFlags } from './Flags/selectors';
import { getCurrentStore } from './refresh/selectors/metaData';

// import SmartLock from './userauth/components/SmartLock.js';

function getItemsDetails(cart, cartItem = []) {
  let ListOfProducts = cartItem.map((eachitem = {}) => {
    const { code: ProductId, quantity: Quantity, size } = eachitem;

    const { Price, CouponSaving, TradeDiscount, MRP } = calculatePriceInfo(eachitem.priceInfo);
    return {
      ProductId,
      Quantity,
      size,

      Price,
      CouponSaving,
      TradeDiscount,
      MRP
    };
  });

  const {
    appliedVouchers: [{ code: CouponId, voucherCode: CouponCode } = {}] = [],
    orderSummary: {
      bagTotal: { formattedValue: BagTotalFormattedValue = '', value: BagTotalValue = 0 } = {},
      bagDiscount: {
        // BagTrade saving
        formattedValue: BagDiscountFormattedValue = '',
        value: BagDiscountValue = 0
      } = {},
      couponSaving: {
        formattedValue: BagCouponSavingFormattedValue = '',
        value: BagCouponSavingValue = 0
      } = {},
      orderTotal: {
        formattedValue: TotalOrderFormattedValue = '',
        value: TotalOrderValue = 0
      } = {},
      deliveryCharge: {
        formattedValue: DeliveryFeeFormattedValue = '',
        value: DeliveryFeeValue = 0
      } = {}
    } = {}
  } = cart;

  const cartDetails = {
    CouponId,
    CouponCode,

    BagCouponSaving: BagCouponSavingFormattedValue,
    TotalOrderValue: TotalOrderFormattedValue,
    DeliveryFee: DeliveryFeeFormattedValue,

    TotalBagSaving: `${BagCouponSavingFormattedValue.split(' ')[0]} ${Math.abs(
      BagCouponSavingValue
    ) + Math.abs(BagDiscountValue)}`,
    BagTotalFormattedValue,
    TradeDiscount: BagDiscountFormattedValue,

    ListOfProducts
  };
  return cartDetails;
}

class AppContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log('v1.2 Deployed');
    if(typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        checkFingerPrintDetails();
      });
    }

    const {
      location = {},
      product: { productDetails = {} } = {},
      request: { totalResults = 0 } = {},
      order = {}
    } = this.props;
    let eventObj = [];

    let params = getParams(location) || {};

    if (Object.keys(readQueryParameter(location)).length) {
      params = { ...params, query: readQueryParameter(location) };
      // let SSO = readCookie("sso");
      // console.log("app sso ", SSO);
      let ssoTokenVal = params.query.at;
      if (ssoTokenVal) {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        if (ssoTokenVal) {
          // Add Secure flag for all environments except localhost
          const isLocalhost = typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
          const secureFlag = isLocalhost ? '' : '; Secure';
          document.cookie = `sso= ${ssoTokenVal}; expires=${now.toGMTString()}; path=/${secureFlag}`;
        }
      }
    }

    for (let key in params) {
      eventObj[`${key}`] = params[key];
    }

    eventObj.Event = 'PageVisit';
    if (location.pathname.includes('/p/')) {
      let {
        variantOptions = [],
        baseOptions = [],
        price: { formattedValue: Price = '' } = {}
      } = productDetails;

      eventObj.Price = Price;
      eventObj.OutOfStock = [];
      eventObj.InStock = [];

      let variants = baseOptions.reduce((accumlator, item) => {
        let { variantType = '' } = item;
        if (variantType === 'FnlSizeVariant') {
          accumlator = item.options || [];
        }
        return accumlator;
      }, []);

      if (variants.length === 0 && variantOptions.length) {
        variants = variantOptions;
      }
      variants.map(item => {
        let {
          code = '',
          stock: { stockLevel = -1, stockLevelStatus } = {},
          modelImage: { altText = '' } = {},
          variantOptionQualifiers = []
        } = item;

        let size = variantOptionQualifiers.reduce((returnVal, item) => {
          let { name = '', value = '', qualifier = '' } = item || {};
          if (name === 'standardSize' && value) {
            returnVal = value;
          } else if (qualifier === 'size' && value) {
            returnVal = value;
          }
          return returnVal;
        }, '');

        if (stockLevel > 0) {
          eventObj.InStock.push(size);
        } else {
          eventObj.OutOfStock.push(size);
        }
      });
    }

    let listingPageRegex = new RegExp('/[s,c,b,search,find]/');
    if (listingPageRegex.test(location.pathname)) {
      eventObj.PageUrl = location.pathname;
      eventObj.NoOfProducts = totalResults;
    } else {
      const { pageId, pageType } = getPageInfo(location.pathname || '');
      const { cartItem, cart } = this.props;
      switch (pageType) {
        case 'Cart':
        case 'Shipping':
        case 'Checkout':
          eventObj = { ...eventObj, ...getItemsDetails(cart, cartItem), pageId };
          break;
        case 'Thankyou': {
          eventObj = { ...eventObj, ...getItemsDetails(order, order.item), pageId };
          break;
        }
        case 'Wishlist': {
          eventObj.PageUrl = location.pathname;
          eventObj.NoOfProducts = totalResults;
          break;
        }
        default:
      }
    }
    sendEvent('PageVisit', eventObj);
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    return (
      <div id="appContainer" className={newDesignLuxe ? 'luxe-newdesign' : null}>
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  let { product = {}, request = {}, cartItem = [], cart = {}, order = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    product,
    request,
    cartItem,
    cart,
    order,
    newDesignLuxe
  };
}
export default withRouter(connect(mapStateToProps, null)(AppContainer));
